<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" hideToggle class="panel-list" [ngClass]="{ expanded: displayMode === DisplayMode.Form }">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Organisations"
                createIconText="Activer une organisation"
                (created)="onOrganizationAdd()"
                (exported)="onOrganizationExported()"
                (helped)="onOrganizationHelped()"></app-list-header>
        </mat-expansion-panel-header>
        <app-organizations-list
            #itemsList
            (itemSelected)="onOrganizationSelected($event)"
            (itemDisplayed)="onOrganizationDisplayed($event)"
            (itemEdited)="onOrganizationEdited($event)"
            (itemDeleted)="onOrganizationDeleted($event)"
            (itemDesactivated)="onOrganizationDesactivated($event)"
            (archivingActivated)="onOrganizationArchivingActivated($event)"></app-organizations-list>
    </mat-expansion-panel>

    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onOrganizationDisplayed(context?.formContext.item)"
                    (edited)="onOrganizationEdited(context?.formContext.item)"
                    (helped)="onOrganizationHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-organization-detail
                [context]="context"
                (organizationUpdated)="onOrganizationUpdated($event)"
                (paramsValuesUpdated)="onParamsValuesUpdated($event)"
                (canceled)="onBackToList()"></app-organization-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
